import cognitoAuth from "./cognitoAuth";

/**
 * Unified logout function that handles both traditional and Cognito sessions
 * Updated to properly clear all Cognito/Amplify storage
 */
export const logout = async (appDispatch, { redirect = true } = {}) => {
  try {
    console.log("🔸 Starting comprehensive logout process...");

    // Step 1: Try Cognito signout (may not clear local storage properly)
    try {
    const isCognitoAuthenticated = await cognitoAuth.isAuthenticated();
    if (isCognitoAuthenticated) {
        console.log("🔸 Cognito user detected, attempting Cognito signout...");
      const result = await cognitoAuth.signOut();
      if (!result.success) {
          console.warn("🔸 Cognito signout had issues:", result.error);
        }
      }
    } catch (cognitoError) {
      console.warn("🔸 Cognito signout failed:", cognitoError.message);
    }

    // Step 2: Aggressively clear ALL browser storage
    console.log("🔸 Clearing all browser storage...");
    
    // Clear sessionStorage completely
    sessionStorage.clear();
    
    // Clear specific localStorage items (legacy)
    const legacyKeys = [
      "complexappToken", "complexappUsername", "complexappAvatar", 
      "userId", "pythanksClientId", "email", "newClient", "emailValidated", 
      "plan", "currentLanguage", "industry"
    ];
    legacyKeys.forEach(key => localStorage.removeItem(key));
    
    // Clear ALL Cognito/Amplify localStorage items
    const cognitoKeys = Object.keys(localStorage).filter(key => 
      key.includes('amplify') || 
      key.includes('cognito') || 
      key.includes('aws') ||
      key.includes('CognitoIdentityServiceProvider') ||
      key.includes('amplify-authenticator') ||
      key.includes('aws-amplify')
    );
    
    console.log("🔸 Clearing Cognito storage keys:", cognitoKeys);
    cognitoKeys.forEach(key => {
      localStorage.removeItem(key);
      console.log("🔸 Removed localStorage key:", key);
    });
    
    // Step 3: Clear IndexedDB (where Amplify sometimes stores tokens)
    if ('indexedDB' in window) {
      try {
        const databases = await indexedDB.databases();
        const amplifyDbs = databases.filter(db => 
          db.name?.includes('amplify') || 
          db.name?.includes('cognito') ||
          db.name?.includes('aws')
        );
        
        for (const db of amplifyDbs) {
          indexedDB.deleteDatabase(db.name);
          console.log("🔸 Deleted IndexedDB:", db.name);
        }
      } catch (idbError) {
        console.warn("🔸 IndexedDB clear failed:", idbError.message);
      }
    }

    // Step 4: Clear any cache storage
    if ('caches' in window) {
      try {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
        console.log("🔸 Cleared cache storage");
      } catch (cacheError) {
        console.warn("🔸 Cache clear failed:", cacheError.message);
      }
    }

    // Step 5: Update React state
    if (appDispatch) {
      appDispatch({ type: "logout" });
    }

    console.log("🔸 Comprehensive logout complete");
    
    // Step 6: Redirect to home page (callers like /connect-mcp opt out to stay in place)
    if (redirect) {
      window.location.href = "/";
    }
    
  } catch (error) {
    console.error("🔸 Error during logout:", error);
    
    // Emergency fallback - clear everything we can
    try {
    sessionStorage.clear();
    localStorage.clear();
    if (appDispatch) {
      appDispatch({ type: "logout" });
    }
    if (redirect) {
      window.location.href = "/";
    }
    } catch (fallbackError) {
      console.error("🔸 Emergency logout fallback failed:", fallbackError);
      // Force page reload as last resort
      window.location.reload();
    }
  }
};

export default logout; 